<template>
    <div class="container pb-4 mb-4">
    <div class="row justify-content-center">
      <div class="col">
        
<div class="row pb-2">
  <div class="col text-center"><h5>Analytics</h5></div>
</div>

<b-card no-body>
      <b-tabs v-model="tabIndex" card align="center">
        <b-tab title="Product Views" title-link-class="darklink">
          <b-card-text><admin-views-list></admin-views-list></b-card-text>
        </b-tab>
        <b-tab title="Most Views" title-link-class="darklink">
          <b-card-text><admin-views-group></admin-views-group></b-card-text>
        </b-tab>
        <b-tab title="Product Clicks" title-link-class="darklink">
          <b-card-text><buy-clicks-list></buy-clicks-list></b-card-text>
        </b-tab>
        <b-tab title="Most Clicks" title-link-class="darklink">
          <b-card-text><buy-clicks-group></buy-clicks-group></b-card-text>
        </b-tab>
        <b-tab title="Most Reviews" title-link-class="darklink">
          <b-card-text><most-reviews></most-reviews></b-card-text>
        </b-tab>
        <b-tab title="Recent Searches" title-link-class="darklink">
          <b-card-text><search-history></search-history></b-card-text>
        </b-tab>
        <b-tab title="Most Searched" title-link-class="darklink">
          <b-card-text><most-searched></most-searched></b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
      </div>
    </div>
  </div>
</template> 

<script>
export default {

  data() {
    return {
      tabIndex: 0,
      creating: false,
    };
  },

}
</script>

<style scoped>
td:hover {cursor: pointer;}
.application_image { width: 100%; border-radius: 0.25rem; }
</style>